<template>
  <v-btn
    rounded
    small
    text
    color="secondary"
    @click="imprimirNotaFiscal()"
    title="Nota Fiscal"
    :icon="isMobile()"
  >
    <v-icon :left="!isMobile()">mdi-file-document-outline</v-icon> <span v-if="!isMobile()">Nota fiscal</span></v-btn
  >
</template>

<script>
import { getToken } from "@/global";

export default {
  props: {
    nf: Object,
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    imprimirNotaFiscal() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/downloads/download-nota-fiscal?token=${getToken()}&nf=${
          this.nf.id
        }&p=${this.nf.pessoa}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>